export const ADD_MESSAGE = 'ADD_MESSAGE';

export const addMessage = (message) => {
  // console.log('🟢 addMessage called with payload:', message);
  return {
    type: ADD_MESSAGE,
    payload: message,
  };
};
